'use client';

import { c as _c } from "react/compiler-runtime";
import { DatePicker } from '../DatePicker';
export function DateRangeInput(props) {
  const $ = _c(13);
  let t0;
  if ($[0] !== props) {
    t0 = value => props.onFromChange(value ?? null);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.from || $[3] !== t0) {
    t1 = <DatePicker className="w-fit rounded-r-none" value={props.from} onChange={t0} />;
    $[2] = props.from;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props) {
    t2 = value_0 => props.onToChange(value_0 ?? null);
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props.to || $[8] !== t2) {
    t3 = <DatePicker className="w-fit rounded-l-none" value={props.to} onChange={t2} />;
    $[7] = props.to;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t3) {
    t4 = <div className="flex w-min">{t1}{t3}</div>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}